// import memberManagementJp from '@/images/pricing/subscribe-member-management-jp.png';

import transcriptAccessControlJp from '@/images/pricing/subscribe-access-control.webp';

import transcriptMemberMangeJp from '@/images/pricing/subscribe-member-management.webp';

import transcriptUserAnalyticsJp from '@/images/pricing/subscribe-usage-analytics.webp';

import transcriptSecurityJp from '@/images/pricing/subscribe-others.webp';

import transcriptIpArrangeJp from '@/images/pricing/subscribe-ip-arrangement.webp';
import { WEB_APP_HOME_URL, WEB_APP_JP_SIGN_UP_URL } from '@/constants';
import { isDevEnv } from '@/constants';

export const MONTH_TIME = 1800;

export const ImageUrl = {
  memberManagement: 'https://a.storyblok.com/f/159374/1016x640/75957415cc/language-en-type.webp',
  memberManagementJp: 'https://a.storyblok.com/f/159374/1016x640/14beb75003/language-jp-type.webp',
  createTeamWorkspace:
    'https://a.storyblok.com/f/159374/1016x640/e49e05691e/language-en-type-new-collaborable-workspace.webp',
  createTeamWorkspaceJp:
    'https://a.storyblok.com/f/159374/1016x640/0aafb4cde5/language-jp-type-new-collaborable-workspace.webp',
  transcriptAccessControl: 'https://a.storyblok.com/f/159374/1016x640/b6077e40fa/language-en-type.webp',
  transcriptAccessControlJp: 'https://a.storyblok.com/f/159374/1016x640/c14a3af65d/language-jp-type.webp',
  transcriptMemberMange: 'https://a.storyblok.com/f/159374/1016x640/75957415cc/language-en-type.webp',
  transcriptUserAnalytics: 'https://a.storyblok.com/f/159374/1016x640/90e3e3a512/language-en-type.webp',
  transcriptSecurity: 'https://a.storyblok.com/f/159374/1016x640/059424cbba/language-en-type.webp',
  transcriptIpArrange: 'https://a.storyblok.com/f/159374/1016x640/3b6654e82f/language-en-type-ip.webp',
  transcriptOnline: 'https://a.storyblok.com/f/159374/1016x640/addab3cebe/language-en-type.webp',
  transcriptOnlineJp: 'https://a.storyblok.com/f/159374/1016x640/2cb5b733f0/language-jp-type.webp',
  chromeExtension: 'https://a.storyblok.com/f/159374/1016x640/48cbd25f21/language-en-type.webp',
  chromeExtensionJp: 'https://a.storyblok.com/f/159374/1016x640/f7af823de1/language-jp-type.webp',
  autoCorrection: 'https://a.storyblok.com/f/159374/1016x640/be80efd4af/language-en-type.webp',
  autoCorrectionJp: 'https://a.storyblok.com/f/159374/1016x640/213aeb8a4f/language-jp-type.webp',
  translation: 'https://a.storyblok.com/f/159374/1016x640/8de6197fd8/language-en-type.webp',
  translationJp: 'https://a.storyblok.com/f/159374/1016x640/ade10c412d/language-jp-type.webp',
  glossary: 'https://a.storyblok.com/f/159374/1016x640/e99da2c62e/language-en-type.webp',
  glossaryJp: 'https://a.storyblok.com/f/159374/1016x640/63f111ed37/language-jp-type.webp',
  pcScreenRecord: 'https://a.storyblok.com/f/159374/1017x640/c839125491/language-en-type.webp',
  pcScreenRecordJp: 'https://a.storyblok.com/f/159374/1016x640/6cae4eb61c/language-jp-type.webp',
  editSpeaker: 'https://a.storyblok.com/f/159374/1016x640/08e30e696a/language-en-type.webp',
  editSpeakerJp: 'https://a.storyblok.com/f/159374/1016x640/d9fe0f501d/language-jp-type.webp',
  videoPlayback: 'https://a.storyblok.com/f/159374/1016x640/427c84e5bb/language-en-type.webp',
  videoPlaybackJP: 'https://a.storyblok.com/f/159374/1016x640/e00cc7670b/language-jp-type.webp',
  aiSummaryJp: 'https://www.notta.ai/pictures/jp-AI-Summary-pricing.webp',
  aiSummaryEn: 'https://www.notta.ai/pictures/en-AI-Summary-pricing.webp',
  salesforceEn: 'https://a.storyblok.com/f/159374/1016x640/83d3ac713a/language-en-type-send-to-salesforce.webp',
  salesforceJp: 'https://a.storyblok.com/f/159374/1016x640/339bec2275/language-jp-type-send-to-salesforce.webp',
  downloadLogEn: 'https://a.storyblok.com/f/159374/1016x640/f16f303875/language-en-type.webp',
  downloadLogJp: 'https://a.storyblok.com/f/159374/1016x640/507f14d8cb/language-jp-type.webp',
  speakerEditEn: 'https://a.storyblok.com/f/159374/1016x640/deb5fb1779/language-en-type.webp',
  speakerEditJp: 'https://a.storyblok.com/f/159374/1016x640/caf4c9f94c/language-jp-type.webp',
  dispatchRobotEn: 'https://a.storyblok.com/f/159374/1016x640/2a1e7b6890/payment-dispatch-robot-transcription-en.webp',
  dispatchRobotJp: 'https://a.storyblok.com/f/159374/1016x640/356a30f7ad/payment-dispatch-robot-transcription-jp.webp',
  skipSilenceEn: 'https://www.notta.ai/pictures/subscribe_review_skip_silence.webp',
  skipSilenceJp: 'https://www.notta.ai/pictures/subscribe_review_skip_silence-jp.webp',
  aiTemplateEn: 'https://www.notta.ai/pictures/ai-template-pricing-page-en.png',
  aiTemplateJp: 'https://www.notta.ai/pictures/ai-template-pricing-page-ja.png',
  realtimeTranscriptionEn: 'https://www.notta.ai/pictures/realtime-transcription-en.webp',
  realtimeTranscriptionJp: 'https://www.notta.ai/pictures/realtime-transcription-ja.webp',
  bilingualTransliterationEn: 'https://www.notta.ai/pictures/bilingual-transliteration-en.webp',
  bilingualTransliterationJp: 'https://www.notta.ai/pictures/bilingual-transliteration-ja.webp',
  automationsJp: 'https://www.notta.ai/pictures/automations-jp-202404091958.webp',
  automationsEn: 'https://www.notta.ai/pictures/automations-en-202404091958.webp',
  zapierEn: 'https://www.notta.ai/pictures/zapier-integration-en-202404151128.webp',
  zapierJp: 'https://www.notta.ai/pictures/zapier-integration-jp-202404151128.webp',
};

// 商品类型
export enum GOODS_TYPE {
  FREE,
  PRO,
  TEAM,
  TEAM_ENTERPRISE,
}

export type PayType = 'month' | 'year';

export type TAveragePrice = {
  month: number | string;
  year: number | string;
};

// 不同商品的信息
export const GOODS_INFO = [
  {
    type: GOODS_TYPE.FREE,
    tag: '',
    name: 'subscribe_free_plan_name',
    description: 'subscribe_free_plan_desc',
    priceDesc: 'nottaweb_landingpage_description_no_credit',
    upgradeTxt: 'subscribe_current_plan',
    upgradeLink: '',
    interest: ['subscribe_free_interest_transcription_time_per_month', 'subscribe_feature_title_1'],
  },
  {
    type: GOODS_TYPE.PRO,
    tag: '',
    name: 'subscribe_pro_plan_name',
    description: 'subscribe_pro_plan_desc',
    priceDesc: {
      year: 'subscribe_card_pro_payment_period_annually',
      month: 'subscribe_card_pro_payment_period_monthly',
    },
    upgradeTxt: 'subscribe_subscribe_page_action_button_name',
    interest: [
      'subscribe_pro_interest_transcription_time_per_month',
      'subscribe_feature_title_1',
      'subscribe_pro_interest_import_media_files',
      'subscribe_pro_interest_export_files',
      'subscribe_pro_interest_vocabulary',
      'subscribe_pro_interest_zoom_meeting_live_transcription',
    ],
  },
  {
    type: GOODS_TYPE.TEAM,
    tag: 'subscribe_team_plan_tag',
    name: 'subscribe_team_plan_name',
    description: 'subscribe_team_plan_desc',
    priceDesc: { year: 'subscribe_card_team_payment_period_annually', month: 'subscribe_team_payment_period_monthly' },
    upgradeTxt: 'subscribe_team_plan_upgrade_btn',
    interest: [
      'subscribe_team_interest_transcription_time_per_month',
      'subscribe_interest_team_management_member',
      'subscribe_interest_team_member_management_record',
      'subscribe_feature_title_1',
      'subscribe_pro_interest_import_media_files',
      'subscribe_pro_interest_export_files',
      'subscribe_pro_interest_vocabulary',
      'subscribe_pro_interest_zoom_meeting_live_transcription',
    ],
  },
  {
    type: GOODS_TYPE.TEAM_ENTERPRISE,
    tag: '',
    name: 'subscribe_enterprise_plan_name',
    description: 'subscribe_enterprise_plan_desc',
    priceDesc: {},
    upgradeTxt: 'subscribe_enterprise_plan_upgrade_btn',
    interest: [
      'subscribe_enterprise_transcription_stripe',
      'subscribe_enterprise_seats_stripe',
      'subscribe_enterprise_payment_stripe',
      'subscribe_enterprise_support_stripe',
    ],
  },
];

export type PlanDataType = {
  type: GOODS_TYPE;
  name: string;
  description: string;
  upgradeTxt?: string;
  upgradeLink: string;
  interestDesc: string;

  interest: Array<{
    text: string;
    tooltip?: { toolTipText: string; toolTipImg: null | { en: any; jp: any } };
    newFeature?: boolean;
    beta?: boolean;
  }>;
  tag: string;
  averagePrice: {
    en: TAveragePrice;
    ja: TAveragePrice;
  };
  priceDesc?:
    | string
    | {
        year: string;
        month: string;
      };
  seats: string;
  transcription_duration:
    | string
    | {
        text: string;
        tooltip: { toolTipText: string; toolTipImg: null | { en: any; jp: any } };
      };
};

export const freePlanData: PlanDataType = {
  type: GOODS_TYPE.FREE,
  name: 'subscribe_free_plan_name',
  description: 'subscribe_free_plan_desc',
  upgradeLink: '',
  interestDesc: 'subscribe_free_interest_text',
  interest: [
    { text: 'subscribe_free_interest_transcription_time_per_month' },
    { text: 'subscribe_feature_free_transcript_time_limit' },
    { text: 'subscribe_free_interest_files_transcribe_lifetime' },
    // { text: 'subscribe_feature_title_11' },
    // { text: 'subscribe_feature_title_1' },
    // { text: 'lead_register_popup_text2' },
    { text: 'subscribe_transcription_notta_bot' },
    // { text: 'subscribe_pricing_page_feature_transcripts' },
    { text: 'subscribe_organize_sync_across_devices' },
    {
      text: 'subscribe_feature_live_screen_recording',
      tooltip: {
        toolTipText: 'subscribe_feature_live_screen_recording_tooltip',
        toolTipImg: {
          en: ImageUrl.pcScreenRecord,
          jp: ImageUrl.pcScreenRecordJp,
        },
      },
      beta: true,
    },
    {
      text: 'subscribe_interest_speaker_identification',
      tooltip: {
        toolTipText: 'subscribe_interest_speaker_identification_desc',
        toolTipImg: {
          en: ImageUrl.speakerEditEn,
          jp: ImageUrl.speakerEditJp,
        },
      },
    },
  ],
  tag: '',
  averagePrice: {
    en: {
      month: 0,
      year: 0,
    },
    ja: {
      month: 0,
      year: 0,
    },
  },
  priceDesc: 'subscribe_no_credit_card_required',
  seats: 'subscribe_just_you',
  transcription_duration: 'subscribe_free_interest_transcription_time_per_month',
  // transcription_duration: {
  //   text: 'subscribe_free_interest_transcription_time_per_month',
  //   tooltip: {
  //     toolTipText: 'subscribe_free_user_transcribe_time_tooltip',
  //     toolTipImg: null,
  //   },
  // },
};

export const proPlanData: PlanDataType = {
  type: GOODS_TYPE.PRO,
  name: 'subscribe_pro_plan_name',
  description: 'subscribe_pro_plan_desc',
  upgradeTxt: 'subscribe_subscribe_page_action_button_name',
  upgradeLink: isDevEnv
    ? 'https://test-app-12154205867b06a3.notta.ai/?from=official&subscribe_type=pro'
    : 'https://app.notta.ai?from=official&subscribe_type=pro',
  interestDesc: 'subscribe_pro_interest_text',
  interest: [
    { text: 'subscribe_pro_interest_transcription_time_per_month' },
    { text: 'subscribe_feature_max_time_transcription_per_record' },
    { text: 'subscribe_pro_interest_media_files_transcribe_month' },
    {
      text: 'subscribe_feature_ai_summary_limit_time',
      beta: true,
    },
    { text: 'subscribe_feature_recordings_and_transcript' },
    {
      text: 'subscribe_feature_transcript_translation',
    },
    {
      text: 'subscribe_pro_interest_vocabulary',
    },
    // { text: 'subscribe_feature_edit_speaker_name' },
  ],
  tag: '',
  averagePrice: { en: { month: 14.99, year: 9 }, ja: { month: 2200, year: 1317 } },
  priceDesc: { year: 'subscribe_card_pro_payment_period_annually', month: 'subscribe_card_pro_payment_period_monthly' },
  seats: 'subscribe_just_you',
  transcription_duration: 'subscribe_pro_interest_transcription_time_per_month',
};

export const teamPlanData: PlanDataType = {
  type: GOODS_TYPE.TEAM,
  name: 'subscribe_team_plan_name',
  description: 'subscribe_team_plan_desc',
  upgradeTxt: 'subscribe_team_plan_upgrade_btn',
  upgradeLink:
    process.env.GATSBY_STORYBLOCK_VERSION === 'draft'
      ? 'https://test-app-12154205867b06a3.notta.ai/?from=official&subscribe_type=team'
      : 'https://app.notta.ai?from=official&subscribe_type=team',
  interestDesc: 'subscribe_team_interest_text',
  interest: [
    // (params) => params + ' 分文字起こし時間 / 月',
    { text: 'subscribe_business_interest_unlimited_transcription_duration' },
    // { text: 'subscribe_team_interest_max_seats_desc' },
    { text: 'subscribe_business_interest_max_5_hours' },
    { text: 'subscribe_business_interest_fifty_media_files' },
    // { text: 'subscribe_business_interest_fifty_ai_summary' },
    {
      text: 'subscribe_feature_meeting_record_video',
    },
    {
      text: 'subscribe_interest_team_management_member',
    },
    {
      text: 'subscribe_feature_security_certification_reports',
    },
    {
      text: 'subscribe_interest_team_usage_analysis_record',
    },
    {
      text: 'subscribe_feature_security_control',
    },
    // {
    //   text: 'subscribe_interest_team_member_management_record',
    // },
    {
      text: 'subscribe_export_to_salesforce',
    },
    {
      text: 'subscribe_zapier_integration',
      newFeature: true,
    },
  ],
  tag: '',
  averagePrice: { en: { month: 27.99, year: 16.67 }, ja: { month: 4180, year: 2508 } },
  priceDesc: { year: 'subscribe_card_team_payment_period_annually', month: 'subscribe_team_payment_period_monthly' },
  seats: 'subscribe_workspace_seats',
  transcription_duration: 'subscribe_free_plan_duration',
};

export const customTeamPlan: PlanDataType = {
  type: GOODS_TYPE.TEAM_ENTERPRISE,
  name: 'subscribe_enterprise_plan_name',
  description: 'subscribe_enterprise_plan_desc',
  upgradeTxt: 'subscribe_enterprise_plan_upgrade_btn',
  upgradeLink: 'https://www.notta.ai/enterprise',
  interestDesc: 'subscribe_enterprise_interest_text',
  interest: [
    {
      text: 'subscribe_enterprise_customize',
    },
    {
      text: 'subscribe_enterprise_sso',
      newFeature: true,
    },
    {
      text: 'subscribe_enterprise_interest_ai_custom_template',
      beta: true,
    },
    { text: 'subscribe_enterprise_not_data_learning' },
    { text: 'subscribe_interest_team_download_log_management' },
    // { text: 'subscribe_enterprise_vocabulary' },
    { text: 'subscribe_enterprise_payment_stripe' },
    { text: 'subscribe_enterprise_support_stripe' },
  ],
  tag: '',
  averagePrice: { en: { month: 'Custom', year: 'Custom' }, ja: { month: '要相談', year: '要相談' } },
  priceDesc: '',
  seats: 'subscribe_enterprise_min_seats_stripe',
  transcription_duration: 'subscribe_enterprise_transcription_stripe',
};

export enum PACKAGE_TAG {
  YEAR = 'year', // 年会员
  MONTH = 'month', // 月会员
  ACT_TRIAL = 'act_trial', // 赠送会员
  SEMI_ANNUAL = 'semi_annual', // 半年会员
  TRIAL = 'trial', // 试用 team workspace
}

// Usage
export const GOODS_USAGE_LIST = [
  {
    title: {
      content: 'subscribe_usage_feature',
    },
    basic: null,
    senior: null,
    team: null,
    enterprise: null,
  },
  // 转写时长
  {
    title: {
      content: 'subscribe_usage_title_1',
    },
    basic: {
      type: 'i18n_time',
      time: 120,
      name: 'subscribe_usage_transcription_local',
      hasTooltip: true,
    },
    senior: {
      type: 'i18n_time',
      time: MONTH_TIME,
      name: 'subscribe_usage_transcription_local',
    },
    team: {
      type: 'component_duration',
      time: MONTH_TIME,
      name: 'subscribe_free_plan_duration',
    },
    enterprise: {
      type: 'i18n',
      name: 'subscribe_enterprise_stipe_desc',
    },
  },
  // 席位
  {
    title: {
      content: 'subscribe_usage_title_seats',
    },
    basic: {
      type: 'text',
      name: '1',
    },
    senior: {
      type: 'text',
      name: '1',
    },
    team: {
      type: 'component',
      name: 'stepper',
    },
    enterprise: {
      type: 'i18n',
      name: 'subscribe_enterprise_stipe_desc',
    },
  },
];

// team work
export const GOODS_TEAM_WORK = [
  {
    title: {
      content: 'subscribe_team_work',
    },
    basic: null,
    senior: null,
    team: null,
    enterprise: null,
  },
  {
    title: {
      content: 'subscribe_interest_team_member_management_record',
      tooltip: {
        title: 'subscribe_interest_team_member_management_desc',
        image: { en: ImageUrl.createTeamWorkspace, jp: ImageUrl.createTeamWorkspaceJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  {
    title: {
      content: 'subscribe_team_interest_file_management',
      tooltip: {
        title: 'subscribe_team_interest_file_management_desc',
        image: { en: ImageUrl.transcriptAccessControl, jp: transcriptAccessControlJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  {
    title: {
      content: 'subscribe_team_member_manage',
      tooltip: {
        title: 'subscribe_enterprise_member_management_desc',
        image: { en: ImageUrl.transcriptMemberMange, jp: transcriptMemberMangeJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  {
    title: {
      content: 'subscribe_interest_team_usage_analysis_record',
      tooltip: {
        title: 'subscribe_interest_team_usage_analysis_desc',
        image: { en: ImageUrl.transcriptUserAnalytics, jp: transcriptUserAnalyticsJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  {
    title: {
      content: 'subscribe_interest_team_download_log_management',
      tooltip: {
        title: 'subscribe_interest_team_download_log_management_desc',
        image: { en: ImageUrl.downloadLogEn, jp: ImageUrl.downloadLogJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'unavailable',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
];

// security
export const SECURITY_LIST = [
  {
    title: {
      content: 'subscribe_security_feature',
    },
    basic: null,
    senior: null,
    team: null,
    enterprise: null,
  },
  {
    title: {
      content: 'subscribe_feature_security_control',
      tooltip: {
        title: 'subscribe_feature_security_control_desc',
        image: { en: ImageUrl.transcriptSecurity, jp: transcriptSecurityJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  {
    title: {
      content: 'subscribe_feature_ip_restriction',
      tooltip: {
        title: 'subscribe_feature_ip_restriction_desc',
        image: { en: ImageUrl.transcriptIpArrange, jp: transcriptIpArrangeJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  {
    title: {
      content: 'subscribe_enterprise_not_data_learning',
      tooltip: {
        title: 'subscribe_enterprise_not_data_learning_desc',
        image: null,
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'unavailable',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  {
    title: {
      content: 'subscribe_enterprise_sso',
      newFeature: true,
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'unavailable',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
];

// Transcription
export const GOODS_TRANSCRIPTION_LIST = [
  {
    title: {
      content: 'subscribe_transcription_feature',
    },
    basic: null,
    senior: null,
    team: null,
    enterprise: null,
  },
  // 实时转写
  {
    title: {
      content: 'subscribe_feature_title_1',
      note: 'subscribe_transcription_realtime_transcript_note',
    },
    basic: {
      type: 'i18n',
      name: 'subscribe_transcription_realtime_transcript_free',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 屏幕录制
  {
    title: {
      content: 'subscribe_feature_live_screen_recording',
      tooltip: {
        title: 'subscribe_feature_live_screen_recording_tooltip',
        image: { en: ImageUrl.pcScreenRecord, jp: ImageUrl.pcScreenRecordJp },
      },
      beta: true,
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 说话人自动识别
  {
    title: {
      content: 'subscribe_interest_speaker_identification',
      tooltip: {
        title: 'subscribe_interest_speaker_identification_desc',
        image: { en: ImageUrl.speakerEditEn, jp: ImageUrl.speakerEditJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 转写语言
  {
    title: {
      content: 'subscribe_feature_title_11',
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 插件
  {
    title: {
      content: 'subscribe_transcription_chrome_extension',
      tooltip: {
        title: 'subscribe_enterprise_chrome_extension_desc',
        image: { en: ImageUrl.chromeExtension, jp: ImageUrl.chromeExtensionJp },
      },
      relatedLink:
        'https://chrome.google.com/webstore/detail/notta-speech-to-text-tran/kdelkaogljjcbjffjmahedaobfjineig',
    },
    basic: {
      type: 'i18n',
      name: 'subscribe_transcription_realtime_transcript_free',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 机器人
  {
    title: {
      content: 'subscribe_transcription_notta_bot',
      tooltip: {
        title: 'subscribe_enterprise_bot_desc',
        image: { en: ImageUrl.transcriptOnline, jp: ImageUrl.transcriptOnlineJp },
      },
    },
    basic: {
      type: 'i18n',
      name: 'subscribe_transcription_realtime_transcript_free',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 日历事件同步
  {
    title: {
      content: 'subscribe_dispatch_robot',
      tooltip: {
        title: 'subscribe_feature_dispatch_robot_desc',
        image: { en: ImageUrl.dispatchRobotEn, jp: ImageUrl.dispatchRobotJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 会议录音
  {
    title: {
      content: 'subscribe_feature_meeting_record_video',
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 录屏回放
  {
    title: {
      content: 'subscribe_feature_video_playback',
      tooltip: {
        title: 'subscribe_feature_video_playback_desc',
        image: { en: ImageUrl.videoPlayback, jp: ImageUrl.videoPlaybackJP },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // AI 总结
  {
    title: {
      content: 'subscribe_feature_ai_summary',
      tooltip: {
        title: 'subscribe_feature_ai_summary_desc',
        image: { en: ImageUrl.aiSummaryEn, jp: ImageUrl.aiSummaryJp },
      },
      beta: true,
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 音频转写
  {
    title: {
      content: 'subscribe_transcription_audio_file',
      tooltip: { title: 'subscribe_enterprise_transcription_aduio_desc' },
    },
    basic: {
      type: 'i18n',
      name: 'subscribe_transcription_audio_file_free',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 视频转写
  {
    title: {
      content: 'subscribe_transcription_video_file',
      tooltip: {
        title: 'subscribe_enterprise_transcription_video_desc',
      },
    },
    basic: {
      type: 'i18n',
      name: 'subscribe_transcription_audio_file_free',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 从URL上传文件
  {
    title: {
      content: 'subscribe_pro_cloud_drive_transcription',
      tooltip: {
        title: 'subscribe_pro_cloud_drive_support_platform',
      },
    },
    basic: {
      type: 'i18n',
      name: 'subscribe_transcription_audio_file_free',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
];

// Edit
export const GOODS_EDIT_LIST = [
  {
    title: {
      content: 'subscribe_edit_feature',
    },
    basic: null,
    senior: null,
    team: null,
    enterprise: null,
  },
  // 打标志
  {
    title: {
      content: 'subscribe_edit_mark_transcript',
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 添加图片
  {
    title: {
      content: 'subscribe_edit_add_image',
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 编辑说话人
  {
    title: {
      content: 'subscribe_edit_speaker',
      tooltip: {
        title: 'subscribe_enterprise_edit_speaker_desc',
        image: { en: ImageUrl.editSpeaker, jp: ImageUrl.editSpeakerJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  //字词集
  {
    title: {
      content: 'subscribe_word_set',
      note: 'subscribe_edit_vocabulary_note',
      tooltip: { title: 'subscribe_edit_vocabulary_note', image: { en: ImageUrl.glossary, jp: ImageUrl.glossaryJp } },
    },
    basic: {
      type: 'text',
      name: 3,
    },
    senior: {
      type: 'text',
      name: 200,
    },
    team: {
      type: 'text',
      name: 1000,
    },
    enterprise: {
      type: 'i18n',
      name: 'subscribe_enterprise_stipe_desc',
    },
  },
  // 隐藏时间戳
  {
    title: {
      content: 'subscribe_edit_hide_timestamps',
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 智能纠错
  {
    title: {
      content: 'subscribe_edit_automatic_correction',
      note: 'subscribe_edit_automatic_correction_note',
      tooltip: {
        title: 'subscribe_edit_automatic_correction_note',
        image: { en: ImageUrl.autoCorrection, jp: ImageUrl.autoCorrectionJp },
      },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 42种转写语言
  {
    title: {
      content: 'subscribe_edit_translation_language',
      note: 'subscribe_edit_translation_language_note',
      tooltip: {
        title: 'subscribe_edit_translation_language_note',
        image: { en: ImageUrl.translation, jp: ImageUrl.translationJp },
      },
      newFeature: true,
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
];

// Review
export const GOODS_REVIEW_LIST = [
  {
    title: {
      content: 'subscribe_review_feature',
    },
    basic: null,
    senior: null,
    team: null,
    enterprise: null,
  },
  // 搜索
  {
    title: {
      content: 'subscribe_review_search',
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 倍速播放
  {
    title: {
      content: 'subscribe_review_playback_speeds',
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 跳过空白音
  {
    title: {
      content: 'subscribe_review_skip_silence',
      tooltip: { title: 'subscribe_review_skip_silence_note' },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
];

// Organize
export const GOODS_ORGANIZE_LIST = [
  {
    title: {
      content: 'subscribe_organize_feature',
    },
    basic: null,
    senior: null,
    team: null,
    enterprise: null,
  },
  // 文件夹
  {
    title: {
      content: 'subscribe_organize_folders',
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 硬件设备同步
  {
    title: {
      content: 'subscribe_organize_sync_across_devices',
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
];

// Export & Share
export const GOODS_EXPORT_SHARE_LIST = [
  {
    title: {
      content: 'subscribe_export_share_feature',
    },
    basic: null,
    senior: null,
    team: null,
    enterprise: null,
  },
  // 转写结果分享
  {
    title: {
      content: 'subscribe_export_share_transcript_share',
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 直播分享
  {
    title: {
      content: 'subscribe_export_share_live_link_share',
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 导出音频
  {
    title: {
      content: 'subscribe_export_share_export_audio',
      tooltip: { title: 'subscribe_enterprise_export_transcript_srt_desc' },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  // 导出转写结果
  {
    title: {
      content: 'subscribe_export_share_export_transcript',
      tooltip: { title: 'subscribe_enterprise_export_transcript_txt_desc' },
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },

  {
    title: {
      content: 'subscribe_export_to_notion',
    },
    basic: {
      type: 'icon',
      name: 'available',
    },
    senior: {
      type: 'icon',
      name: 'available',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
  {
    title: {
      content: 'subscribe_export_to_salesforce',
      note: 'subscribe_export_to_salesforce_tooltip_title',
      tooltip: {
        title: 'subscribe_export_to_salesforce_tooltip_title',
        image: { en: ImageUrl.salesforceEn, jp: ImageUrl.salesforceJp },
      },
      newFeature: true,
    },
    basic: {
      type: 'icon',
      name: 'unavailable',
    },
    senior: {
      type: 'icon',
      name: 'unavailable',
    },
    team: {
      type: 'icon',
      name: 'available',
    },
    enterprise: {
      type: 'icon',
      name: 'available',
    },
  },
];

export const GOODS_LIST = {
  usage: GOODS_USAGE_LIST,
  teamwork: GOODS_TEAM_WORK,
  security: SECURITY_LIST,
  transcription: GOODS_TRANSCRIPTION_LIST,
  edit: GOODS_EDIT_LIST,
  review: GOODS_REVIEW_LIST,
  organize: GOODS_ORGANIZE_LIST,
  export_share: GOODS_EXPORT_SHARE_LIST,
};

export const WORKSPACE_MIN_SEATS = 2;
export const WORKSPACE_MAX_SEATS = 20;

export interface ICompareTablePlanItem {
  type: GOODS_TYPE;
  planName: string;
  planDesc:
    | string
    | {
        year: string;
        month: string;
      };
  btnLabel: string;
  btnLink: string;
}

// Compare table header
export const COMPARE_TABLE_HEADER: ICompareTablePlanItem[] = [
  {
    type: GOODS_TYPE.FREE,
    planName: 'subscribe_free_plan_name',
    planDesc: 'subscribe_no_credit_card_required',
    btnLabel: '無料ではじめる',
    btnLink: WEB_APP_JP_SIGN_UP_URL,
  },
  {
    type: GOODS_TYPE.PRO,
    planName: 'subscribe_pro_plan_name',
    planDesc: {
      year: 'subscribe_pro_payment_period_annually',
      month: 'subscribe_pro_payment_period_monthly',
    },
    btnLabel: 'subscribe_subscribe_page_action_button_name',
    btnLink: WEB_APP_HOME_URL,
  },
  {
    type: GOODS_TYPE.TEAM,
    planName: 'subscribe_team_plan_name',
    planDesc: {
      year: 'subscribe_pro_payment_period_annually',
      month: 'subscribe_pro_payment_period_monthly',
    },
    btnLabel: 'subscribe_team_plan_upgrade_btn',
    btnLink: WEB_APP_HOME_URL,
  },
  {
    type: GOODS_TYPE.TEAM_ENTERPRISE,
    planName: 'subscribe_enterprise_plan_name',
    planDesc: 'subscribe_enterprise_price_desc',
    btnLabel: 'subscribe_enterprise_plan_upgrade_btn',
    btnLink: WEB_APP_HOME_URL,
  },
];

export type CellType =
  | {
      type: 'icon';
      name: 'unavailable' | 'available';
    }
  | {
      type: 'select';
      suffix?: string;
    }
  | {
      type: 'stepper';
      suffix?: string;
    }
  | {
      type: 'text';
      content: string;
      tooltip?: {
        title?: string;
        image?: {
          en?: string;
          jp?: string;
        };
      };
      relatedLink?: string;
    }
  | {
      type: 'calc';
      singleValue: number;
      unit: string;
    };

export type TitleCell = {
  isNewFeature?: boolean;
  isBeta?: boolean;
  isAddOn?: boolean;
};

export interface IRightItem {
  title: string;
  rightDetailList: {
    title: CellType & TitleCell;
    free: CellType;
    pro: CellType;
    team: CellType;
    custom: CellType;
  }[];
}

export const GOODS_TYPE_MAP = {
  [GOODS_TYPE.FREE]: 'free',
  [GOODS_TYPE.PRO]: 'pro',
  [GOODS_TYPE.TEAM]: 'team',
  [GOODS_TYPE.TEAM_ENTERPRISE]: 'custom',
};

export const RIGHT_LIST: IRightItem[] = [
  // Usage
  {
    title: 'subscribe_usage_feature',
    rightDetailList: [
      // 转写时长
      {
        title: {
          type: 'text',
          content: 'subscribe_usage_title_1',
        },
        free: {
          type: 'text',
          content: 'subscribe_free_interest_transcription_time_per_month',
          // tooltip: {
          //   title: 'subscribe_free_user_transcribe_time_tooltip',
          // },
        },
        pro: {
          type: 'text',
          content: 'subscribe_pro_interest_transcription_time_per_month',
        },
        team: {
          type: 'text',
          content: 'subscribe_business_transcription_quota_desc',
          tooltip: {
            title: 'subscribe_business_interest_unlimited_tips',
          },
        },
        custom: {
          type: 'text',
          content: 'subscribe_enterprise_stipe_desc',
        },
      },
      // 席位
      {
        title: {
          type: 'text',
          content: 'subscribe_usage_title_seats',
        },
        free: {
          type: 'text',
          content: '1',
        },
        pro: {
          type: 'text',
          content: '1',
        },
        team: {
          type: 'stepper',
        },
        custom: {
          type: 'text',
          content: 'subscribe_feature_team_transcription_quota',
        },
      },
      // Max transcription per recording
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_max_recording_title',
        },
        free: {
          type: 'text',
          content: 'subscribe_feature_free_max_recording_desc',
          tooltip: {
            title: 'subscribe_free_user_transcribe_time_tooltip',
          },
        },
        pro: {
          type: 'text',
          content: 'subscribe_feature_pro_max_transcription_per_recording',
        },
        team: {
          type: 'text',
          content: 'subscribe_feature_common_recording_title',
        },
        custom: {
          type: 'text',
          content: 'subscribe_feature_common_recording_title',
        },
      },
    ],
  },
  // Automatic transcription
  {
    title: 'subscribe_transcription_feature',
    rightDetailList: [
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_title_1',
          tooltip: {
            title: 'subscribe_feature_realtime_transcription_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_interest_automatic_transcription_number_file_transfers_title',
          tooltip: {
            title: 'subscribe_file_transcript_hovered_desc',
          },
        },
        free: {
          type: 'text',
          content: 'subscribe_interest_fifty_times',
        },
        pro: {
          type: 'text',
          content: 'subscribe_interest_one_hundred_times',
        },
        team: {
          type: 'calc',
          singleValue: 200,
          unit: 'subscribe_interest_any_times',
        },
        custom: {
          type: 'text',
          content: 'subscribe_business_transcription_quota_desc',
        },
      },
      // 从URL上传文件
      // {
      //   title: {
      //     type: 'text',
      //     content: 'subscribe_pro_cloud_drive_transcription',
      //     tooltip: {
      //       title: 'subscribe_pro_cloud_drive_transcription_hovered_desc',
      //     },
      //   },
      //   free: {
      //     type: 'icon',
      //     name: 'available',
      //   },
      //   pro: {
      //     type: 'icon',
      //     name: 'available',
      //   },
      //   team: {
      //     type: 'icon',
      //     name: 'available',
      //   },
      //   custom: {
      //     type: 'icon',
      //     name: 'available',
      //   },
      // },
      // 机器人
      {
        title: {
          type: 'text',
          content: 'subscribe_transcription_notta_bot',
          tooltip: {
            title: 'subscribe_enterprise_bot_desc',
            image: { en: ImageUrl.transcriptOnline, jp: ImageUrl.transcriptOnlineJp },
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      // 插件
      {
        title: {
          type: 'text',
          content: 'subscribe_transcription_chrome_extension',
          tooltip: {
            title: 'subscribe_enterprise_chrome_extension_desc',
            image: { en: ImageUrl.chromeExtension, jp: ImageUrl.chromeExtensionJp },
          },
          relatedLink:
            'https://chrome.google.com/webstore/detail/notta-speech-to-text-tran/kdelkaogljjcbjffjmahedaobfjineig',
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      // 屏幕录制
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_live_screen_recording',
          tooltip: {
            title: 'subscribe_feature_live_screen_recording_tooltip',
            image: { en: ImageUrl.pcScreenRecord, jp: ImageUrl.pcScreenRecordJp },
          },
          isBeta: true,
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      // 说话人自动识别
      {
        title: {
          type: 'text',
          content: 'subscribe_interest_speaker_identification',
          tooltip: {
            title: 'subscribe_interest_speaker_identification_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      // 硬件设备同步
      {
        title: {
          type: 'text',
          content: 'subscribe_organize_sync_across_devices',
          tooltip: {
            title: 'subscribe_organize_sync_across_devices_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      // Customize vocabulary (Japanese only)
      {
        title: {
          type: 'text',
          content: 'subscribe_pro_interest_vocabulary',
          tooltip: {
            title: 'subscribe_edit_vocabulary_note',
            image: {
              en: ImageUrl.glossary,
              jp: ImageUrl.glossaryJp,
            },
          },
        },
        free: {
          type: 'text',
          content: 'subscribe_vocabulary_feature_free',
        },
        pro: {
          type: 'text',
          content: 'subscribe_vocabulary_feature_pro',
        },
        team: {
          type: 'text',
          content: 'subscribe_vocabulary_feature_business',
        },
        custom: {
          type: 'text',
          content: 'subscribe_business_transcription_quota_desc',
        },
      },
      // AI 总结
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_ai_summary_title',
          tooltip: {
            title: 'subscribe_feature_ai_summary_desc',
            image: { en: ImageUrl.aiSummaryEn, jp: ImageUrl.aiSummaryJp },
          },
          isBeta: true,
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'text',
          content: 'subscribe_interest_twenty_times',
        },
        team: {
          type: 'calc',
          singleValue: 50,
          unit: 'subscribe_interest_any_times',
        },
        custom: {
          type: 'text',
          content: 'subscribe_business_transcription_quota_desc',
        },
      },
      // Customized AI template
      {
        title: {
          type: 'text',
          content: 'subscribe_enterprise_interest_ai_custom_template',
          tooltip: {
            title: 'subscribe_enterprise_interest_ai_custom_template_desc',
            image: { en: ImageUrl.aiTemplateEn, jp: ImageUrl.aiTemplateJp },
          },
          isBeta: true,
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'unavailable',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_transcript_translation',
          tooltip: {
            title: 'subscribe_feature_transcript_translation_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_meeting_record_video',
          tooltip: {
            title: 'subscribe_feature_video_playback_desc',
            image: {
              en: ImageUrl.videoPlayback,
              jp: ImageUrl.videoPlaybackJP,
            },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_auto_ai_summary',
          isNewFeature: true,
          tooltip: {
            title: 'subscribe_auto_ai_summary_tooltips_desc',
            image: {
              en: ImageUrl.automationsEn,
              jp: ImageUrl.automationsJp,
            },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      // 双语转写
      {
        title: {
          type: 'text',
          content: 'subscribe_bilingual_transcription_title',
          tooltip: {
            title: 'subscribe_enterprise_bilingual_transcription_tooltip',
            image: { en: ImageUrl.bilingualTransliterationEn, jp: ImageUrl.bilingualTransliterationJp },
          },
          isAddOn: true,
        },
        free: {
          type: 'text',
          content: 'subscribe_interest_two_times',
        },
        pro: {
          type: 'text',
          content: 'subscribe_interest_two_times',
        },
        team: {
          type: 'text',
          content: 'subscribe_interest_two_times',
        },
        custom: {
          type: 'text',
          content: 'subscribe_transcription_module_add_on',
        },
      },
      // realtime_transcription
      {
        title: {
          type: 'text',
          content: 'subscribe_realtime_transcription_title',
          tooltip: {
            title: 'subscribe_enterprise_realtime_transcription_tooltip',
            image: { en: ImageUrl.realtimeTranscriptionEn, jp: ImageUrl.realtimeTranscriptionJp },
          },
          isAddOn: true,
        },
        free: {
          type: 'text',
          content: 'subscribe_interest_two_times',
        },
        pro: {
          type: 'text',
          content: 'subscribe_interest_two_times',
        },
        team: {
          type: 'text',
          content: 'subscribe_interest_two_times',
        },
        custom: {
          type: 'text',
          content: 'subscribe_transcription_module_add_on',
        },
      },
    ],
  },
  // Playback & Editing
  {
    title: 'subscribe_feature_recording_and_playback',
    rightDetailList: [
      {
        title: {
          type: 'text',
          content: 'subscribe_edit_feature',
          tooltip: {
            title: 'subscribe_edit_feature_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_time_stamped_notes',
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_edit_add_image',
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_review_search',
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_find_and_replace',
          tooltip: {
            title: 'subscribe_feature_find_and_replace_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_edit_speaker',
          tooltip: {
            title: 'subscribe_enterprise_edit_speaker_desc',
            image: { en: ImageUrl.editSpeaker, jp: ImageUrl.editSpeakerJp },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      // 智能纠错
      {
        title: {
          type: 'text',
          content: 'subscribe_edit_automatic_correction',
          tooltip: {
            title: 'subscribe_edit_automatic_correction_note',
            image: { en: ImageUrl.autoCorrection, jp: ImageUrl.autoCorrectionJp },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      // 倍速播放
      {
        title: {
          type: 'text',
          content: 'subscribe_review_playback_speeds',
          tooltip: {
            title: 'subscribe_review_playback_speeds_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      // 跳过空白音
      {
        title: {
          type: 'text',
          content: 'subscribe_review_skip_silence',
          tooltip: {
            title: 'subscribe_review_skip_silence_note',
            image: {
              en: ImageUrl.skipSilenceEn,
              jp: ImageUrl.skipSilenceJp,
            },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
    ],
  },
  // shared & Collaborate
  {
    title: 'subscribe_feature_shared_and_collaborate',
    rightDetailList: [
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_appointment_scheduling',
          tooltip: {
            title: 'subscribe_feature_appointment_scheduling_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_shared_snippet',
          tooltip: {
            title: 'subscribe_feature_shared_snippet_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_share_with_password',
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_folder_management',
          tooltip: {
            title: 'subscribe_team_interest_file_management_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_export_transcripts_and_recordings',
          tooltip: {
            title: 'subscribe_feature_export_transcripts_and_recordings_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_interest_team_member_management_record',
          tooltip: {
            title: 'subscribe_interest_team_member_management_desc',
            image: { en: ImageUrl.createTeamWorkspace, jp: ImageUrl.createTeamWorkspaceJp },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
    ],
  },
  // Integrations
  {
    title: 'subscribe_feature_integrations',
    rightDetailList: [
      {
        title: {
          type: 'text',
          content: 'scheduler_location_zoom',
          tooltip: {
            title: 'scheduler_location_zoom_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_outlook_calendar',
          tooltip: {
            title: 'subscribe_feature_outlook_calendar_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_google_calendar',
          tooltip: {
            title: 'subscribe_feature_google_calendar_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_notion',
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'settings_preference_integrations_salesforce_title',
          tooltip: {
            title: 'subscribe_export_to_salesforce_tooltip_title',
            image: {
              en: ImageUrl.salesforceEn,
              jp: ImageUrl.salesforceJp,
            },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'settings_preference_integrations_zapier_title',
          tooltip: {
            title: 'subscribe_zapier_integration_tooltip_title',
            image: {
              en: ImageUrl.zapierEn,
              jp: ImageUrl.zapierJp,
            },
          },
          isNewFeature: true,
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'settings_preference_integrations_hubspot_title',
          isNewFeature: true,
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
    ],
  },
  // Admin & security
  {
    title: 'subscribe_feature_admin_and_security',
    rightDetailList: [
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_ssl_encryption',
          tooltip: {
            title: 'subscribe_feature_ssl_encryption_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'available',
        },
        pro: {
          type: 'icon',
          name: 'available',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_security_control',
          tooltip: {
            title: 'subscribe_feature_security_control_desc',
            image: { en: ImageUrl.transcriptSecurity, jp: transcriptSecurityJp },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_permissions_management',
          tooltip: {
            title: 'subscribe_enterprise_member_management_desc',
            image: {
              en: ImageUrl.memberManagement,
              jp: ImageUrl.memberManagementJp,
            },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_interest_team_usage_analysis_record',
          tooltip: {
            title: 'subscribe_interest_team_usage_analysis_desc',
            image: { en: ImageUrl.transcriptUserAnalytics, jp: transcriptUserAnalyticsJp },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_security_certification_reports',
          tooltip: {
            title: 'subscribe_feature_security_certification_reports_hovered_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'available',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_feature_ip_restriction',
          tooltip: {
            title: 'subscribe_feature_ip_restriction_desc',
            image: { en: ImageUrl.transcriptIpArrange, jp: transcriptIpArrangeJp },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'text',
          content: '20',
        },
        custom: {
          type: 'text',
          content: '1,000',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_enterprise_not_data_learning',
          tooltip: {
            title: 'subscribe_enterprise_not_data_learning_desc',
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'unavailable',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_enterprise_sso',
          isNewFeature: true,
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'unavailable',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_interest_team_download_log_management',
          tooltip: {
            title: 'subscribe_interest_team_download_log_management_desc',
            image: { en: ImageUrl.downloadLogEn, jp: ImageUrl.downloadLogJp },
          },
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'unavailable',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'subscribe_enterprise_support_stripe',
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'unavailable',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
      {
        title: {
          type: 'text',
          content: 'settings_auto_deletion_title',
        },
        free: {
          type: 'icon',
          name: 'unavailable',
        },
        pro: {
          type: 'icon',
          name: 'unavailable',
        },
        team: {
          type: 'icon',
          name: 'unavailable',
        },
        custom: {
          type: 'icon',
          name: 'available',
        },
      },
    ],
  },
];
